import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone, X, MessageSquare, MessageCircle, MapPin, ChevronUp } from 'lucide-react';
import { useData } from '../context/DataContext';
import { getSettingMapUrl } from '../utils/branchUtils';

const FloatingWidget = ({ onOpenBooking }) => {
    const { settings } = useData();
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 400);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 992);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // If mobile, we already have the bottom sticky bar in Header, so maybe hide this or keep it.
    // The user's screenshot applies to desktop mostly, but can be visible on mobile too.
    // Let's hide on mobile if they have the bottom bar, but we'll use d-none d-lg-block to be safe.

    const toggleOpen = () => setIsOpen(!isOpen);

    return (
        <div className="d-none d-lg-block" style={{
            position: 'fixed',
            bottom: 40,
            right: 40,
            zIndex: 9999,
        }}>
            {/* Pop-up Menu */}
            <div style={{
                position: 'absolute',
                bottom: 155,
                right: 0,
                width: 220,
                background: '#fff',
                borderRadius: 12,
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                padding: '10px 0',
                transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                transformOrigin: 'bottom right',
                transform: isOpen ? 'scale(1)' : 'scale(0.8)',
                opacity: isOpen ? 1 : 0,
                visibility: isOpen ? 'visible' : 'hidden',
                pointerEvents: isOpen ? 'auto' : 'none',
            }}>
                {/* Small triangle arrow at the bottom pointing to the button */}
                <div style={{
                    position: 'absolute',
                    bottom: -8,
                    right: 22,
                    borderWidth: '8px 8px 0',
                    borderStyle: 'solid',
                    borderColor: '#fff transparent transparent transparent',
                }}></div>

                <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                    <li style={{ padding: '8px 16px' }}>
                        <Link to="/dat-lich-hen" onClick={() => setIsOpen(false)} style={{
                            display: 'flex', alignItems: 'center', background: 'none', border: 'none', padding: 0, textDecoration: 'none', color: '#333', width: '100%', cursor: 'pointer'
                        }}>
                            <div style={{
                                width: 40, height: 40, borderRadius: '50%', background: '#ff0000',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 15, flexShrink: 0
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>
                                </svg>
                            </div>
                            <span style={{ fontSize: 15, fontWeight: 400 }}>Đặt lịch</span>
                        </Link>
                    </li>
                    <li style={{ padding: '8px 16px' }}>
                        <a href={settings?.zaloUrl} target="_blank" rel="noreferrer" style={{
                            display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#333'
                        }}>
                            <div style={{
                                width: 40, height: 40, borderRadius: '50%', background: '#ff0000',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 15, flexShrink: 0
                            }}>
                                <span style={{ color: '#fff', fontWeight: 700, fontSize: 13, display: 'flex' }}>Zalo</span>
                            </div>
                            <span style={{ fontSize: 15, fontWeight: 400 }}>Zalo</span>
                        </a>
                    </li>
                    <li style={{ padding: '8px 16px' }}>
                        <a href={settings?.messageUrl} target="_blank" rel="noreferrer" style={{
                            display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#333'
                        }}>
                            <div style={{
                                width: 40, height: 40, borderRadius: '50%', background: '#ff0000',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 15, flexShrink: 0
                            }}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2C6.477 2 2 6.145 2 11.259c0 2.91 1.487 5.502 3.824 7.22.146.108.243.272.261.45l.23 2.155c.032.296.347.469.61.336l2.394-1.214a.634.634 0 0 1 .494-.038c.683.242 1.417.377 2.187.377 5.523 0 10-4.145 10-9.259S17.523 2 12 2zm1.09 12.39l-2.404-2.571a.636.636 0 0 0-.91-.027l-3.21 3.018c-.282.264-.71.1-.64-.28l1.455-5.328a.636.636 0 0 1 .45-.458l2.585-.688a.636.636 0 0 1 .655.207l2.253 2.651a.636.636 0 0 0 .937.04l3.125-2.905c.29-.269.721-.087.632.302l-1.558 5.76a.636.636 0 0 1-.486.467l-2.522.61a.636.636 0 0 1-.362-.08z" fill="#fff" />
                                </svg>
                            </div>
                            <span style={{ fontSize: 15, fontWeight: 400 }}>Messenger</span>
                        </a>
                    </li>
                    <li style={{ padding: '8px 16px' }}>
                        <a href={`tel:${settings?.hotline}`} style={{
                            display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#333'
                        }}>
                            <div style={{
                                width: 40, height: 40, borderRadius: '50%', background: '#ff0000',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 15, flexShrink: 0
                            }}>
                                <Phone size={20} color="#fff" strokeWidth={2.5} />
                            </div>
                            <span style={{ fontSize: 15, fontWeight: 400 }}>Hotline</span>
                        </a>
                    </li>
                    <li style={{ padding: '8px 16px' }}>
                        <a href={getSettingMapUrl(settings?.address)} target="_blank" rel="noreferrer" style={{
                            display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#333'
                        }}>
                            <div style={{
                                width: 40, height: 40, borderRadius: '50%', background: '#ff0000',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 15, flexShrink: 0
                            }}>
                                <MapPin size={20} color="#fff" strokeWidth={2.5} />
                            </div>
                            <span style={{ fontSize: 15, fontWeight: 400 }}>Chỉ đường</span>
                        </a>
                    </li>
                </ul>
            </div>

            {/* Main Toggle Button */}
            <button
                onClick={toggleOpen}
                style={{
                    position: 'absolute',
                    bottom: 75,
                    right: 0,
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    background: '#ff0000',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(255, 0, 0, 0.4)',
                    zIndex: 2,
                    transition: 'transform 0.3s ease',
                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
            >
                {isOpen ? (
                    <X size={28} color="#fff" strokeWidth={3} />
                ) : (
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" fill="#fff" />
                        <path d="M8 10h8M8 14h4" stroke="#ff0000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                )}
            </button>

            {/* Pulse effect rings behind the button when closed */}
            {!isOpen && (
                <>
                    <div style={{
                        position: 'absolute',
                        bottom: 65,
                        right: -10,
                        width: 80,
                        height: 80,
                        borderRadius: '50%',
                        background: 'rgba(255, 0, 0, 0.4)',
                        zIndex: 1,
                        animation: 'pulse-ring 2s infinite',
                    }} />
                    <div style={{
                        position: 'absolute',
                        bottom: 55,
                        right: -20,
                        width: 100,
                        height: 100,
                        borderRadius: '50%',
                        background: 'rgba(255, 0, 0, 0.2)',
                        zIndex: 0,
                        animation: 'pulse-ring 2s infinite 0.5s',
                    }} />
                </>
            )}

            {/* Scroll to Top Button */}
            <button
                onClick={scrollToTop}
                style={{
                    position: 'absolute',
                    bottom: 0,
                    right: 5,
                    width: 50,
                    height: 50,
                    borderRadius: '50%',
                    background: '#fff',
                    border: '2px solid #ff0000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                    zIndex: 2,
                    transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    transform: showScrollTop ? 'scale(1)' : 'scale(0) rotate(-180deg)',
                    opacity: showScrollTop ? 1 : 0,
                    pointerEvents: showScrollTop ? 'auto' : 'none',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#ff0000'; e.currentTarget.querySelector('svg').style.stroke = '#fff'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.querySelector('svg').style.stroke = '#ff0000'; }}
            >
                <ChevronUp size={28} color="#ff0000" strokeWidth={3} style={{ transition: 'all 0.3s' }} />
            </button>

            {/* Add keyframes for pulse animation if not exists */}
            <style>
                {`
                    @keyframes pulse-ring {
                        0% { transform: scale(0.6); opacity: 1; }
                        100% { transform: scale(1.2); opacity: 0; }
                    }
                `}
            </style>
        </div>
    );
};

export default FloatingWidget;



